var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpGy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 795"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 90",
    d: "M13 12L5 12L9 7L13 12Z",
    fill: "#777777"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpGy);
export default __webpack_public_path__ + "static/media/arrow-up-gy.427e291dd1f434c969583f859e9f869d.svg";
export { ForwardRef as ReactComponent };